import { Skeleton } from '../../Skeleton'

import * as styles from './EntityProfileHeaderActionsContainer.module.css'

function EntityProfileHeaderActionsContainer({
  Actions,
  className = styles.EntityProfileHeaderActionsContainer,
  isLoading,
  ...restProps
}) {
  return Actions ? (
    <div className={className}>
      {isLoading ? (
        <Skeleton className={styles.skeleton} />
      ) : (
        <Actions {...restProps} />
      )}
    </div>
  ) : null
}

export default EntityProfileHeaderActionsContainer
